import { URLS } from '../../../consts/endpoints';
import { translate } from '../../../i18n/I18nProvider';
import { getData } from '../../../utils/http';
import {
  doesArrayHasLength,
  isArray,
  isDefined
} from '../../../utils/isDefined';
import { actions as reduxActions } from '../reducers';

const mapAccounts = ({ clientId, category = 'IoT' }) => {
  return async dispatch => {
    let accountsSelectsOptions = [];
    let products = [];
    try {
      const data = await getData(`${URLS.QUOTE_CLIENTS}/${clientId}/accounts`);

      const mappedAcounts = createSelectOptions(data);

      if (doesArrayHasLength(mappedAcounts)) {
        const customerAccount = mappedAcounts.find(
          account => account.type === 'CUSTOMER'
        );

        if (isDefined(customerAccount)) {
          const productsUrl =
            category === 'IoT'
              ? `${URLS.QUOTE_CLIENTS}/${clientId}/products?account_reference=${customerAccount.externalReference}&category=IoT`
              : `${URLS.QUOTE_CLIENTS}/${clientId}/products?account_reference=${customerAccount.externalReference}`;

          const response = await getData(productsUrl);

          if (isDefined(response?.[customerAccount.externalReference])) {
            const accountProducts = response[customerAccount.externalReference];

            products =
              category === 'IoT'
                ? accountProducts
                : accountProducts.filter(product =>
                    product.sku?.includes('MBB')
                  );
          }
        }
      }

      accountsSelectsOptions = mappedAcounts;
    } finally {
      if (doesArrayHasLength(accountsSelectsOptions)) {
        dispatch(reduxActions.setAccounts(accountsSelectsOptions));
        dispatch(reduxActions.setSelectedAccount(accountsSelectsOptions[0]));
        dispatch(reduxActions.setProducts(products));
      }
    }
  };
};

export default mapAccounts;

const createSelectOptions = (data = []) => {
  if (!isArray(data) || data.length === 0) {
    return [{ value: '', label: translate('NONE') }];
  }

  const options = data.map(el => {
    const { id, name, accountNo } = el;
    return { value: id, label: `${name} - ${accountNo}`, ...el };
  });

  if (options.length > 1) {
    return [
      {
        externalReference: 'all',
        value: 'all',
        label: translate('INVOICES.ALL_ACCOUNTS'),
        name: translate('INVOICES.ALL_ACCOUNTS')
      },
      ...options
    ];
  }

  return options;
};
